import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02f63eab"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-map d-flex justify-content-center align-items-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Espere por favor"),
  /*#__PURE__*/_createElementVNode("span", null, "Localizando..........")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "map-container",
  ref: "mapElement"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isUserlocationReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
      [_vShow, _ctx.isUserlocationReady]
    ])
  ], 64))
}